export function mTel(tel) {
  if (tel) {
    tel = tel.replace(/\D/g, "")
    tel = tel.replace(/^(\d)/, "($1")
    tel = tel.replace(/(.{3})(\d)/, "$1)$2")
    if (tel.length === 9) {
      tel = tel.replace(/(.{1})$/, "-$1")
    } else if (tel.length === 10) {
      tel = tel.replace(/(.{2})$/, "-$1")
    } else if (tel.length === 11) {
      tel = tel.replace(/(.{3})$/, "-$1")
    } else if (tel.length === 12) {
      tel = tel.replace(/(.{4})$/, "-$1")
    } else if (tel.length > 12) {
      tel = tel.replace(/(.{4})$/, "-$1")
    }
  }
  return tel;
}

export function mCNPJ(cnpj) {
  try {
    if (cnpj) {
      cnpj = cnpj.toUpperCase().replace(/[^A-Z0-9]/g, '')

      cnpj = cnpj.substring(0, 14)

      if (cnpj.length > 12) {
        cnpj = cnpj.replace(/^(.{2})(.{3})(.{3})(.{4})(.{0,2}).*/, '$1.$2.$3/$4-$5')
      } else if (cnpj.length > 8) {
        cnpj = cnpj.replace(/^(.{2})(.{3})(.{3})(.{0,4}).*/, '$1.$2.$3/$4')
      } else if (cnpj.length > 5) {
        cnpj = cnpj.replace(/^(.{2})(.{3})(.{0,3}).*/, '$1.$2.$3')
      } else if (cnpj.length > 2) {
        cnpj = cnpj.replace(/^(.{2})(.{0,3}).*/, '$1.$2')
      }
    }
  } catch (error) {}
  return cnpj
}

export function mCPF(cpf) {
  if (cpf) {
    cpf = cpf.replace(/\D/g, "")
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2")
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2")
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
  } else
    cpf = ''
  return cpf
}

export function mCEP(cep) {
  cep = cep.replace(/\D/g, "")
  cep = cep.replace(/^(\d{2})(\d)/, "$1.$2")
  cep = cep.replace(/\.(\d{3})(\d)/, ".$1-$2")
  return cep
}

export function mNum(num) {
  num = num.replace(/\D/g, "")
  return num
}

export function mHora(hora) {
  hora = hora.replace(/\D/g, "")
  hora = hora.substr(0, 2) + ":" + hora.substr(2, 2)

  return hora;
}

export function mValidade(validade) {
  if (validade) {
    validade = validade.replace(/\D/g, "")
    validade = validade.substr(0, 2) + "/" + validade.substr(2, 4)
  }
  return validade;
}

export function mCompetencia(competencia) {
  if (competencia) {
    competencia = competencia.replace(/\D/g, "")
    competencia = competencia.replace(/(\d{4})(\d)/, "$1/$2")
  }
  return competencia;
}

String.prototype.reverse = function () {
  return this.split('').reverse().join('');
};


export function mVAL(val) {

  var v = String(val).replace(/\D/g, "");

  v = (v / 100).toFixed(2) + "";

  v = v.replace(".", ",");

  v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,");

  v = v.replace(/(\d)(\d{3}),/g, "$1.$2,");
  
  return v;

}

export function mCAR(car) {

  car = car.replace(/(\w{4})(\w)/, "$1-$2")
  car = car.replace(/(\w{4})(\w)/, "$1-$2")
  car = car.replace(/(\w{4})(\w)/, "$1-$2")
  car = car.replace(/(\w{4})(\w)/, "$1-$2")
  return car
}

export function mPERC(int) {

  var tmp = int + '';
  tmp = tmp.replace(/\D/g, "")
  tmp = Number(tmp)
  tmp = String(tmp)
  if (tmp.length == 1) {
    tmp = tmp.replace(/([0-9]{1})$/g, "0,0$1");
  }
  else if (tmp.length == 2) {
    tmp = tmp.replace(/([0-9]{2})$/g, "0,$1");
  }
  else if (tmp.length > 2) {
    tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
  }
  if (tmp.length > 6)
    tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");

  return tmp;
}



